const extractArtifacts = (content: string): { artifacts: string[]; text: string } => {
	const artifacts: string[] = [];
	let text = content.replace(/```html\s*\n?([\s\S]*?)```/g, (_, html) => {
		artifacts.push(html.trim());
		return "";
	});
	if (artifacts.length === 0) {
		text = text.replace(/(<!DOCTYPE html[\s\S]*?<\/html>)/gi, (match) => {
			artifacts.push(match.trim());
			return "";
		});
	}
	return { artifacts, text: text.trim() };
};

export default extractArtifacts;
